@if (isVisible()) {
  <div class="menu-backdrop" (click)="onMenuClose()"></div>
  <div class="menu-container">
    <div class="menu-item" (click)="onAddComment()">
      <span class="menu-icon">
        <mat-icon>comment</mat-icon>
      </span>
      <span class="menu-text">{{ addCommentText }}</span>
    </div>

    <div class="menu-item" (click)="onAddPhotoComment()">
      <span class="menu-icon">
        <mat-icon>add_a_photo</mat-icon>
      </span>
      <span class="menu-text">{{ addPhotoCommentText }}</span>
    </div>

    @if (itemInputColorControlEnabled()) {
      <div class="menu-item" (click)="onOpenInputColorPicker()">
        <span class="menu-icon">
          <mat-icon>palette</mat-icon>
        </span>
        <span class="menu-text">{{ setInputColor }}</span>
        <input
          class="menu-color-picker"
          type="color"
          [value]="itemInputColorLive()"
          (input)="onInputColorChange($event)"
          #colorPicker />
      </div>

      <div
        [ngClass]="[!isRemoveInputColorEnabled() ? 'menu-item-disabled' : '']"
        class="menu-item"
        (click)="onRemoveInputColor()">
        <span class="menu-icon">
          <mat-icon>format_color_reset</mat-icon>
        </span>
        <span class="menu-text">{{ removeInputColor }}</span>
      </div>
    }

    @if (itemSelectionColorControlEnabled()) {
      <div class="menu-item" (click)="onOpenTableColorPicker()">
        <span class="menu-icon">
          <mat-icon>format_color_fill</mat-icon>
        </span>
        <span class="menu-text">{{ setSelectionColor }}</span>
        <input
          class="menu-color-picker"
          type="color"
          [value]="itemSelectionColorLive()"
          (input)="onSelectionColorChange($event)"
          #colorPickerTable />
      </div>

      <div class="menu-item" (click)="onRemoveSelectionColor()">
        <span class="menu-icon">
          <mat-icon>format_color_reset</mat-icon>
        </span>
        <span class="menu-text">{{ removeSelectionColor }}</span>
      </div>
    }

    @if (debug()) {
      <div class="menu-separator"></div>
      <div class="menu-item" (click)="onGetXml()">
        <span class="menu-icon">
          <mat-icon>code</mat-icon>
        </span>
        <span class="menu-text">{{ getXmlText }}</span>
      </div>
      <div class="menu-item" (click)="onGetFormattedXml()">
        <span class="menu-icon">
          <mat-icon>format_indent_increase</mat-icon>
        </span>
        <span class="menu-text">{{ getFormattedXmlText }}</span>
      </div>
    }

    @if (showDeleteOption()) {
      <div class="menu-separator"></div>
      <div class="menu-item menu-item-danger" (click)="onDeleteItem()">
        <span class="menu-icon">
          <mat-icon>delete</mat-icon>
        </span>
        <span class="menu-text">{{ deleteItemText }}</span>
      </div>
    }
  </div>
}
